import { forwardRef } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { useUIDSeed } from 'react-uid'

import Button from 'components/Button'
import Accordion from 'components/Accordion'

import style from './Operate.style'

const OperateStyled = styled.div(props => ({ ...style(props) }))

const Operate = forwardRef(
    ({ title, titleTag: TitleTag, subtitle, text, operatedItems, textBottom, buttonText, buttonLink }, ref) => {
        const uid = useUIDSeed()

        return (
            <OperateStyled ref={ref}>
                <div className="OperateContainer">
                    <TitleTag className="Title" dangerouslySetInnerHTML={{ __html: title }} />
                    <div className="BlockCaption">
                        {subtitle && <p className="Subtitle">{subtitle}</p>}
                        {text && <p className="Text">{text}</p>}
                    </div>
                    {operatedItems && operatedItems.length > 0 && (
                        <div className="AccordionContainer">
                            {operatedItems.map(item => (
                                <Accordion key={uid(item)} title={item.title} text={item.text} />
                            ))}
                            {textBottom && (
                                <div className="AccordionBottom">
                                    <p className="AccordionText">{textBottom}</p>
                                    <Button
                                        link={buttonLink}
                                        white
                                        small
                                        variation="primary rounded"
                                        dataAttrs={{
                                            'gtm-event': 'link',
                                            'gtm-label': title,
                                            'gtm-action': buttonText,
                                            'gtm-category': 'Operate'
                                        }}>
                                        {buttonText}
                                    </Button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </OperateStyled>
        )
    }
)

Operate.propTypes = {
    title: PropTypes.string,
    titleTag: PropTypes.string,
    subtitle: PropTypes.string,
    text: PropTypes.string,
    operatedItems: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            text: PropTypes.string
        })
    ),
    textBottom: PropTypes.string,
    buttonText: PropTypes.string,
    buttonLink: PropTypes.string
}

Operate.defaultProps = {
    titleTag: 'p',
    title: null,
    text: null,
    operatedItems: [],
    textBottom: null,
    subtitle: null,
    buttonText: null,
    buttonLink: null
}

export default withTheme(Operate)
